module.exports = __webpack_public_path__ + "img/waves-9.3c8950cb.jpg";